export default __webpack_public_path__ + "static/media/SconeMixProductInfo2.a8b4788a.gif";